/**
 * Converia.Invoice.ElectronMockService
 */
Converia.Core.module('Converia.Invoice.ElectronMockService', function () {
    var MOCK_RESULT_SUCCESS = 100;
    var MOCK_RESULT_ERROR = 1000;
    var MOCK_RESULT_NO_RESPONSE = 10000;

    /**
     * ElectronMockService
     * 
     * @constructor
     */
    var ElectronMockService = function () {
        this.price = 0;
        this.mockbehaviour = MOCK_RESULT_SUCCESS;
    };

    /**
     * ElectronMockService.prototype.inElectron
     * 
     * @returns {boolean}
     */
    ElectronMockService.prototype.inElectron = function () {
        return true;
    };

    /**
     * ElectronMockService.prototype.send
     * 
     * @param eventName
     * @param data
     */
    ElectronMockService.prototype.send = function (eventName, data) {
        if (eventName !== 'request-payment' ) {
            return;
        }
        this.price = data.price;
        var mockbehaviour = '';

        if (this.price <= MOCK_RESULT_SUCCESS) {
            this.mockbehaviour = MOCK_RESULT_SUCCESS;
            mockbehaviour = 'SUCCESS';
        } else if (this.price <= MOCK_RESULT_ERROR) {
            this.mockbehaviour = MOCK_RESULT_ERROR;
            mockbehaviour = 'ERROR';
        } else {
            this.mockbehaviour = MOCK_RESULT_NO_RESPONSE;
            mockbehaviour = 'TIMEOUT';
        }
        console.log('Payment over: ' + this.price + ' should be processed. Amount defines mock result and is: ' + mockbehaviour);
    };

    /**
     * ElectronMockService.prototype.removeAllListeners
     * 
     * @param eventName
     */
    ElectronMockService.prototype.removeAllListeners = function (eventName) {

    };

    /**
     * ElectronMockService.prototype.once
     * 
     * @param eventName
     * @param callback
     */
    ElectronMockService.prototype.once = function (eventName, callback) {
        if (this.mockbehaviour === MOCK_RESULT_NO_RESPONSE) {
            console.log('We simulate no response .');
        } else {
            var result_code = (this.mockbehaviour === MOCK_RESULT_ERROR) ? 100 : 0;

            console.log('Waiting 2 seconds for callback from electron service.');

            window.setTimeout(function () {
                var event = document.createEvent('Event');
                var responseData = {
                    result_code: result_code,
                    result_msg: 'Mock message',
                    payment_id: 'gdsfd4324',
                    reference_number: '1234a12334',
                };

                callback(event, responseData);
            }, 2000);
        }
    };

    return ElectronMockService;
});